export default function formatDuration(seconds: number): string {
    const hours = Math.trunc(seconds / 3600)
    const hourRemainder = seconds % 3600
    const minutes = Math.trunc(hourRemainder / 60)

    return `${hours !== 0 ? `${hours}h` : ""}${hours !== 0 && minutes !== 0 ? " " : ""}${
        minutes !== 0 || hours === 0 ? `${minutes}min` : ""
    }`
}
